import numberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { connect } from "react-redux";
export default connect(state => ({
  value: state.firstRiders.firstTimeRiders.firstTimeRides.prevFirstTimeRidesYTD,
  disableAnimation: state.firstRiders.currentUser.qa
}))(numberDisplay);
